/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_SubtitleInputs */

const en_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File claims, explore your services, and understand your coverage — all from one secure place.`)
};

const fr_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soumettez des réclamations, explorez vos services et comprenez votre couverture — le tout en un seul endroit sécurisé.`)
};

/**
* | output |
* | --- |
* | "File claims, explore your services, and understand your coverage — all from one secure place." |
*
* @param {Home_Hero_SubtitleInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_hero_subtitle = /** @type {((inputs?: Home_Hero_SubtitleInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_SubtitleInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_hero_subtitle(inputs)
	return fr_home_hero_subtitle(inputs)
});